import { getSeoRedirectSSR } from '@/features/seo-listing/api/seo.requests.ssr';
import { isPermalinkPath } from '@/features/seo-listing/consts';

/**
 * When seo/resolve returns 404 for a permalink (SEO page disabled), land on the
 * canonical GET listing URL. Prefer /seo/redirect's toUrl when it yields a GET
 * path (numeric ids). Avoid following another permalink target (loop risk).
 */
export const resolveDisabledPermalinkFallbackHref = async (
  permalinkPath: string,
  catalogFallbackHref: string,
): Promise<string> => {
  const pathname = permalinkPath.split('?')[0] ?? permalinkPath;
  const redirectResult = await getSeoRedirectSSR(pathname);

  if (redirectResult.status !== 'redirect') {
    return catalogFallbackHref;
  }

  const toUrl = redirectResult.data.toUrl;
  const toPath = toUrl.split('?')[0] ?? '';
  if (isPermalinkPath(toPath)) {
    return catalogFallbackHref;
  }

  return toUrl;
};
